module.exports = __webpack_public_path__ + "img/TopState2G.b51f5311.png";